var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.042 201.667C161.287 201.667 173.406 201.667 182.114 194.737C190.822 187.797 193.591 175.936 199.146 152.203L216.718 77.0641C219.789 63.9283 221.329 57.3558 218.542 52.5891C213.473 43.9633 200.557 45.8333 192.124 45.8333",
    stroke: "#97C4E4",
    strokeWidth: 8.13454,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.666 82.5002C36.666 52.2502 36.666 37.1252 46.0618 27.7293C55.4577 18.3335 70.5827 18.3335 100.833 18.3335H128.333C158.583 18.3335 173.708 18.3335 183.104 27.7293C192.499 37.1252 192.499 52.2502 192.499 82.5002V137.5C192.499 167.75 192.499 182.875 183.104 192.271C173.708 201.667 158.583 201.667 128.333 201.667H100.833C70.5827 201.667 55.4577 201.667 46.0618 192.271C36.666 182.875 36.666 167.75 36.666 137.5V82.5002Z",
    stroke: "#97C4E4",
    strokeWidth: 8.13454
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.583 55.0001C124.307 55.0001 133.634 58.8632 140.51 65.7395C147.386 72.6159 151.249 81.9422 151.249 91.6668C151.249 101.391 147.386 110.718 140.51 117.594C133.634 124.47 124.307 128.333 114.583 128.333M114.583 55.0001C104.858 55.0001 95.5318 58.8632 88.6554 65.7395C81.7791 72.6159 77.916 81.9422 77.916 91.6668C77.916 101.391 81.7791 110.718 88.6554 117.594C95.5318 124.47 104.858 128.333 114.583 128.333M114.583 55.0001C106.993 55.0001 100.833 71.4085 100.833 91.6668C100.833 111.925 106.993 128.333 114.583 128.333M114.583 55.0001C122.173 55.0001 128.333 71.4085 128.333 91.6668C128.333 111.925 122.173 128.333 114.583 128.333",
    stroke: "#97C4E4",
    strokeWidth: 8.13454
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4995 155.833H146.666",
    stroke: "#97C4E4",
    strokeWidth: 8.13454,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIcon);
export default __webpack_public_path__ + "static/media/heroIcon.817bdb073e212691d1fad47974e6bf69.svg";
export { ForwardRef as ReactComponent };